export const DEVICES_BULK_UNPAIRING_OPEN_MODAL = "DEVICES_BULK_UNPAIRING_OPEN_MODAL";
export const DEVICES_BULK_UNPAIRING_CLOSE_MODAL = "DEVICES_BULK_UNPAIRING_CLOSE_MODAL";
export const DEVICES_BULK_UNPAIRING_REQUEST = "DEVICES_BULK_UNPAIRING_REQUEST";
export const DEVICES_BULK_UNPAIRING_RESULT = "DEVICES_BULK_UNPAIRING_RESULT";

export const DEVICES_BULK_SEARCH_DEVICE_REQUEST = "DEVICES_BULK_SEARCH_DEVICE_REQUEST";
export const DEVICES_BULK_SEARCH_DEVICE_RESULT = "DEVICES_BULK_SEARCH_DEVICE_RESULT";

export const DEVICES_BULK_UNPAIRING_SET_DEVICE = "DEVICES_BULK_UNPAIRING_SET_DEVICE";